interface SlaRow {
  Id: number;
  TicketSlas?: unknown[];
}

/**
 * After a save in a cell the list reloads its page. A ticket the save left alone - its modified date unchanged - keeps
 * the SLA pills it was showing, so the column does not blank and draw again; only the rest are fetched (Shaun,
 * 2026-10-23). Returns the rows that still need their SLAs. Not for a refresh or a new page: an SLA can breach while
 * its ticket stays the same.
 */
export const keepUnchangedSlas = <T extends SlaRow>(
  rows: T[],
  before: T[],
  modifiedOf: (row: T) => string | undefined,
  isTicket: (row: T) => boolean = () => true,
): T[] => {
  const shown = new Map(before.filter(row => isTicket(row) && row.TicketSlas).map(row => [row.Id, row] as [number, T]));
  return rows.filter(row => {
    if (!isTicket(row)) return false;
    const old = shown.get(row.Id);
    if (old && modifiedOf(old) === modifiedOf(row)) {
      row.TicketSlas = old.TicketSlas;
      return false;
    }
    return true;
  });
};
